import React from 'react';
import { segmentTrackEvent } from '../utils';

const SecondaryRecipe = ({
  subSection,
  isMobile,
  sectionIndex,
}) => {
  const {
    type,
    moduleType,
    title,
    subTitle,
    img,
    ingredients,
    directions,
  } = subSection;

  const subhedClass = `sub-section-subhed ${type}-hed`;

  const renderedIngredients = ingredients.map((ingredient, i) => {
    const ingredientsTracker = {
      module: 'Secondary Recipe',
      category: 'checkbox',
      linkType: 'checkbox',
      label: `box-checked-for-${ingredient}`,
    };
    return (
      <label className="checkbox" key={`ingredient ${i}`} onClick={() => segmentTrackEvent('checkbox_clicked', ingredientsTracker)}>
        <input type="checkbox" key={`checkbox input ${i}`} />
        <span>{ingredient}</span>
      </label>
    );
  });

  const renderedDirections = <ol className="directions-list" type="1">
      {directions.map((step, i) => (<li className="step" key={`step #${i}`}>{step}</li>))}</ol>;

  return (
    <>
        <div className="sub-section-image-container">
            <img src={isMobile ? img.mobile : img.desktop} className="sub-section-image"></img>
        </div>
        <div className="sub-section-copy second-recipe">
            <div className="sub-section-copy-wrapper">
                <h4 className="sub-section-subtitle" dangerouslySetInnerHTML={{ __html: subTitle }}></h4>
                <h3 className={subhedClass} dangerouslySetInnerHTML={{ __html: title }}></h3>
                <div className="ingredients-wrapper">
                  <h4 className="ingredients-header">Ingredients:</h4>
                  <div className="ingredients-list">
                    {renderedIngredients}
                  </div>
                </div>
                <div className="directions-wrapper">
                  <h4 className="directions-header">Directions:</h4>
                  {renderedDirections}
                </div>
            </div>
        </div>
    </>
  );
};

export default SecondaryRecipe;
